


















import { UserRights } from "@/configuration/authentication";
import { Zone } from "@/model/Zone";
import { UserDetailsResponse } from "@/model/user/UserDetailsResponse";
import { StoreService } from "@/services/StoreService";
import { UserService } from "@/services/UserService";
import { Component, Vue } from "vue-property-decorator";
import { Inject } from "vue-typedi";
import UsersSearch from "@/components/users/UsersSearch.vue";
import UsersRightsManagement from "@/components/users/UsersRightsManagement.vue";

@Component({ components: { UsersSearch, UsersRightsManagement } })
export default class UsersBody extends Vue {

    @Inject()
    storeService!: StoreService;
    @Inject()
    userService!: UserService;

    allZones: Zone[] = [];
    isFound: boolean = false;
    hasError: boolean = false;
    errorCode: string = "";
    userDetails: UserDetailsResponse = null;
    rolesUser: { [key: string]: string } = {};
    connectedUser: UserRights = null;
    storeId: string = '';

    created() {
        this.storeService.getStoreById().then(store => {
            this.storeId = store.storeId;
            if (!store.zones) {
                this.allZones = [];
                return;
            }
            this.allZones = store.zones;
        });

        this.userService.getUserRights().then(userRights => {
            this.connectedUser = userRights;
        })
    }

    setupUserDetails(user: UserDetailsResponse) {
        this.userDetails = user;
        this.allZones.forEach((zone) => {
            const acrFound = this.userDetails.userAccreditations.find(userAcr => userAcr.zone === zone.zoneCode);
            if (acrFound != null) {
                this.rolesUser[zone.zoneCode] = acrFound.role;
                return;
            }
            this.rolesUser[zone.zoneCode] = null;
        })
    }

    search(searchTerm: string) {
        this.userService.getUserDetails(searchTerm, this.storeId).then(response => {
            this.setupUserDetails(response);
            this.isFound = true;
            this.hasError = false;
            this.errorCode = "";
        }).catch(error => {
            this.hasError = true;
            this.isFound = false;
            this.errorCode = error?.response?.data?.error;
        });
    }

    back() {
        this.userDetails = null;
        this.isFound = false;
        this.hasError = false;
    }

    save(rolesUser: any) {
        this.rolesUser = rolesUser;
        this.userDetails.userAccreditations.length = 0;
        Object.entries(this.rolesUser).forEach(([key, value]) => {
          this.userDetails.userAccreditations.push({zone: key, role: value});
        });
        this.userService.updateUserDetails(this.userDetails,this.storeId).then(response => {
            this.setupUserDetails(response);
        })
    }

}
